module.exports = __webpack_public_path__ + "img/Download.d56d99d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/Download.png
// module id = c9ie
// module chunks = 1